export function isEmptyOrSpace(str: string | undefined): boolean {
  return str === undefined || str.match(/^ *$/) !== null;
}
